// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content {
  height: 200px;
  width: 100%;
  background-image: url("/assets/img/logo_semplice.png");
  background-repeat: no-repeat;
  margin-bottom: 20px;
}
.content ion-icon {
  font-size: 50px;
}

ion-icon {
  margin-right: 10px;
}

.userIcon {
  margin-left: 15px;
}

ion-menu ion-content {
  --background: var(--ion-item-background, var(--ion-background-color, #fff));
}

ion-menu.md ion-content {
  --padding-start: 8px;
  --padding-end: 8px;
  --padding-top: 20px;
  --padding-bottom: 20px;
}

ion-menu.md ion-list {
  padding: 10px 0;
}

ion-menu.md ion-note {
  margin-bottom: 30px;
}

ion-menu.md ion-list-header,
ion-menu.md ion-note {
  padding-left: 10px;
}

ion-menu.md ion-list#inbox-list ion-list-header {
  font-size: 22px;
  font-weight: 500;
  min-height: 20px;
}

ion-menu.md ion-list#labels-list ion-list-header {
  font-size: 16px;
  margin-bottom: 18px;
  color: #757575;
  min-height: 26px;
}

ion-menu.md ion-item {
  --padding-start: 10px;
  --padding-end: 10px;
  border-radius: 4px;
}

ion-menu.md ion-item.selected {
  --background: rgba(var(--ion-color-primary-rgb), 0.14);
}

ion-menu.md ion-item.selected ion-icon {
  color: var(--ion-color-primary);
}

ion-menu.md ion-item ion-icon {
  color: #616e7e;
}

ion-menu.ios ion-content {
  --padding-bottom: 20px;
}

ion-menu.ios ion-list {
  padding: 20px 0 0 0;
}

ion-menu.ios ion-note {
  line-height: 24px;
  margin-bottom: 20px;
}

ion-menu.ios ion-item {
  --padding-start: 16px;
  --padding-end: 16px;
  --min-height: 50px;
}

ion-menu.ios ion-item.selected ion-icon {
  color: var(--ion-color-primary);
}

ion-menu.ios ion-item ion-icon {
  font-size: 24px;
  color: #73849a;
}

ion-menu.ios ion-list#labels-list ion-list-header {
  margin-bottom: 8px;
}

ion-menu.ios ion-list-header,
ion-menu.ios ion-note {
  padding-left: 16px;
  padding-right: 16px;
}

ion-menu.ios ion-note {
  margin-bottom: 8px;
}

ion-note {
  display: inline-block;
  font-size: 16px;
  color: var(--ion-color-medium-shade);
}

ion-item.selected {
  --color: var(--ion-color-primary);
}

ion-icon {
  margin-right: 10px;
}

.menu-user-data-icon {
  font-size: 24px;
}

ion-item {
  padding: 3px 10px 3px 5px;
  height: 40px;
  display: flex;
  align-items: center;
}
ion-item ion-label {
  font-weight: 300;
  color: #616e7e;
  font-size: 15px;
}

ion-content {
  padding: 0 !important;
  --padding-end: 0 !important;
  --padding-start: 0 !important;
  --padding-top: 0 !important;
  --padding-bottom: 0 !important;
  --overflow: hidden;
}

.container-powered-by {
  position: relative;
  bottom: 0;
  left: 0;
  width: 100%;
  font-size: 11px;
  text-align: center;
  padding: 5px 0;
  color: rgba(0, 0, 0, 0.7);
  margin: 0 auto;
}

ion-list {
  height: calc(100vh - 254px);
  overflow-y: auto;
}

.container-user-data {
  border-bottom: 2px solid grey;
  padding-bottom: 20px;
  margin: 0 15px;
}

.container-user-row-field {
  padding-left: 0;
  padding-right: 0;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}
.container-user-row-field:not(:first-child) {
  margin-top: 10px;
}

.container-text-user-data {
  font-size: 15px;
}

.menu-wifi-icon.connected-lan {
  color: var(--ion-color-primary, #0cd1e8) !important;
}
.menu-wifi-icon.connected-wan {
  color: var(--ion-color-warning, #ffce00) !important;
}
.menu-wifi-icon.no-connection {
  animation: blink 2s infinite;
}

@keyframes blink {
  0% {
    color: #ffffff;
  }
  25% {
    color: #e74c3c;
  }
  75% {
    color: #e74c3c;
  }
  100% {
    color: #ffffff;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/app.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,WAAA;EACA,sDAAA;EACA,4BAAA;EACA,mBAAA;AACF;AACE;EACE,eAAA;AACJ;;AAGA;EACE,kBAAA;AAAF;;AAEA;EACE,iBAAA;AACF;;AAEA;EACE,2EAAA;AACF;;AAEA;EACE,oBAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;;EAEE,kBAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EAEA,gBAAA;AAAF;;AAGA;EACE,eAAA;EAEA,mBAAA;EAEA,cAAA;EAEA,gBAAA;AAHF;;AAMA;EACE,qBAAA;EACA,mBAAA;EACA,kBAAA;AAHF;;AAMA;EACE,sDAAA;AAHF;;AAMA;EACE,+BAAA;AAHF;;AAMA;EACE,cAAA;AAHF;;AAMA;EACE,sBAAA;AAHF;;AAMA;EACE,mBAAA;AAHF;;AAMA;EACE,iBAAA;EACA,mBAAA;AAHF;;AAMA;EACE,qBAAA;EACA,mBAAA;EACA,kBAAA;AAHF;;AAMA;EACE,+BAAA;AAHF;;AAMA;EACE,eAAA;EACA,cAAA;AAHF;;AAMA;EACE,kBAAA;AAHF;;AAMA;;EAEE,kBAAA;EACA,mBAAA;AAHF;;AAMA;EACE,kBAAA;AAHF;;AAMA;EACE,qBAAA;EACA,eAAA;EAEA,oCAAA;AAJF;;AAOA;EACE,iCAAA;AAJF;;AAOA;EACE,kBAAA;AAJF;;AAOA;EACE,eAAA;AAJF;;AAOA;EACE,yBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;AAJF;AAME;EACE,gBAAA;EACA,cAAA;EACA,eAAA;AAJJ;;AAQA;EACE,qBAAA;EACA,2BAAA;EACA,6BAAA;EACA,2BAAA;EAEA,8BAAA;EACA,kBAAA;AANF;;AASA;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;EAEA,yBAAA;EACA,cAAA;AAPF;;AAUA;EACE,2BAAA;EACA,gBAAA;AAPF;;AAUA;EACE,6BAAA;EACA,oBAAA;EACA,cAAA;AAPF;;AAUA;EACE,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,mBAAA;AAPF;AASE;EACE,gBAAA;AAPJ;;AAWA;EACE,eAAA;AARF;;AAYE;EACE,mDAAA;AATJ;AAYE;EACE,mDAAA;AAVJ;AAaE;EAEE,4BAAA;AAZJ;;AAgBA;EACE;IACE,cAAA;EAbF;EAeA;IACE,cAAA;EAbF;EAeA;IACE,cAAA;EAbF;EAeA;IACE,cAAA;EAbF;AACF","sourcesContent":[".content {\n  height: 200px;\n  width: 100%;\n  background-image: url(\"/assets/img/logo_semplice.png\");\n  background-repeat: no-repeat;\n  margin-bottom: 20px;\n\n  ion-icon {\n    font-size: 50px;\n  }\n}\n\nion-icon {\n  margin-right: 10px;\n}\n.userIcon {\n  margin-left: 15px;\n}\n\nion-menu ion-content {\n  --background: var(--ion-item-background, var(--ion-background-color, #fff));\n}\n\nion-menu.md ion-content {\n  --padding-start: 8px;\n  --padding-end: 8px;\n  --padding-top: 20px;\n  --padding-bottom: 20px;\n}\n\nion-menu.md ion-list {\n  padding: 10px 0;\n}\n\nion-menu.md ion-note {\n  margin-bottom: 30px;\n}\n\nion-menu.md ion-list-header,\nion-menu.md ion-note {\n  padding-left: 10px;\n}\n\nion-menu.md ion-list#inbox-list ion-list-header {\n  font-size: 22px;\n  font-weight: 500;\n\n  min-height: 20px;\n}\n\nion-menu.md ion-list#labels-list ion-list-header {\n  font-size: 16px;\n\n  margin-bottom: 18px;\n\n  color: #757575;\n\n  min-height: 26px;\n}\n\nion-menu.md ion-item {\n  --padding-start: 10px;\n  --padding-end: 10px;\n  border-radius: 4px;\n}\n\nion-menu.md ion-item.selected {\n  --background: rgba(var(--ion-color-primary-rgb), 0.14);\n}\n\nion-menu.md ion-item.selected ion-icon {\n  color: var(--ion-color-primary);\n}\n\nion-menu.md ion-item ion-icon {\n  color: #616e7e;\n}\n\nion-menu.ios ion-content {\n  --padding-bottom: 20px;\n}\n\nion-menu.ios ion-list {\n  padding: 20px 0 0 0;\n}\n\nion-menu.ios ion-note {\n  line-height: 24px;\n  margin-bottom: 20px;\n}\n\nion-menu.ios ion-item {\n  --padding-start: 16px;\n  --padding-end: 16px;\n  --min-height: 50px;\n}\n\nion-menu.ios ion-item.selected ion-icon {\n  color: var(--ion-color-primary);\n}\n\nion-menu.ios ion-item ion-icon {\n  font-size: 24px;\n  color: #73849a;\n}\n\nion-menu.ios ion-list#labels-list ion-list-header {\n  margin-bottom: 8px;\n}\n\nion-menu.ios ion-list-header,\nion-menu.ios ion-note {\n  padding-left: 16px;\n  padding-right: 16px;\n}\n\nion-menu.ios ion-note {\n  margin-bottom: 8px;\n}\n\nion-note {\n  display: inline-block;\n  font-size: 16px;\n\n  color: var(--ion-color-medium-shade);\n}\n\nion-item.selected {\n  --color: var(--ion-color-primary);\n}\n\nion-icon {\n  margin-right: 10px;\n}\n\n.menu-user-data-icon {\n  font-size: 24px;\n}\n\nion-item {\n  padding: 3px 10px 3px 5px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n\n  ion-label {\n    font-weight: 300;\n    color: #616e7e;\n    font-size: 15px;\n  }\n}\n\nion-content {\n  padding: 0 !important;\n  --padding-end: 0 !important;\n  --padding-start: 0 !important;\n  --padding-top: 0 !important;\n\n  --padding-bottom: 0 !important;\n  --overflow: hidden;\n}\n\n.container-powered-by {\n  position: relative;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  font-size: 11px;\n  text-align: center;\n  padding: 5px 0;\n\n  color: rgb(0, 0, 0, 0.7);\n  margin: 0 auto;\n}\n\nion-list {\n  height: calc(100vh - 254px);\n  overflow-y: auto;\n}\n\n.container-user-data {\n  border-bottom: 2px solid grey;\n  padding-bottom: 20px;\n  margin: 0 15px;\n}\n\n.container-user-row-field {\n  padding-left: 0;\n  padding-right: 0;\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  align-items: center;\n\n  &:not(:first-child) {\n    margin-top: 10px;\n  }\n}\n\n.container-text-user-data {\n  font-size: 15px;\n}\n\n.menu-wifi-icon {\n  &.connected-lan {\n    color: var(--ion-color-primary, #0cd1e8) !important;\n  }\n\n  &.connected-wan {\n    color: var(--ion-color-warning, #ffce00) !important;\n  }\n\n  &.no-connection {\n    //color: var(--ion-color-primary, #0cd1e8) !important;\n    animation: blink 2s infinite;\n  }\n}\n\n@keyframes blink {\n  0% {\n    color: #ffffff;\n  }\n  25% {\n    color: #e74c3c;\n  }\n  75% {\n    color: #e74c3c;\n  }\n  100% {\n    color: #ffffff;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
